import React, { useCallback, useContext, useMemo } from 'react';
import { useLoader } from '../../api/useLoader';
import {
  BrukerrollerDto,
  RolleDto,
  StudiestedbrukerDto,
  StudiestedRollerDto,
} from '../../api/generated/studiested-generated-api';
import { StudiestedApiContext } from '../../api/StudiestedApiContext';
import translations from '../rolleliste.i18n';
import { useFormatMessageFor } from '../../i18n/translation';
import Autocomplete from '../../components/input/autocomplete';

interface RollelisteStudiestedbrukerDropDownProps {
  id: string;
  rollerData: RolleDto[] | undefined;
  rolleTypeStudiested: StudiestedRollerDto | undefined;
  onChange: (selectedItem?: StudiestedbrukerDto) => void;
}

const RollelisteStudiestedbrukerDropDown = ({
  id,
  rollerData,
  rolleTypeStudiested,
  onChange,
}: RollelisteStudiestedbrukerDropDownProps) => {
  const labels = useFormatMessageFor(translations);

  const { studiestedApi } = useContext(StudiestedApiContext);

  const { data: studiestedbrukereData, loading: studiestedbrukereLoading } =
    useLoader(() => studiestedApi.studiestedbrukereGet({}), []);

  const existsStudiestedbrukerRolle = useCallback(
    (aId: string, roleType: StudiestedRollerDto) => {
      return (rollerData ?? [])
        .filter((v: RolleDto) => v.type.studiestedrolle === roleType)
        .map((v) => v.id)
        .includes(aId);
    },
    [rollerData],
  );

  const filtrerteStudiestedbrukere = useMemo(() => {
    switch (rolleTypeStudiested) {
      case StudiestedRollerDto.Koordinator:
        return studiestedbrukereData?.filter(
          (val) =>
            (val.tilgangsrolle === BrukerrollerDto.Administrator ||
              val.tilgangsrolle === BrukerrollerDto.Skriverettighet) &&
            !existsStudiestedbrukerRolle(val.id, rolleTypeStudiested),
        );
      case StudiestedRollerDto.Underviser:
        return studiestedbrukereData?.filter(
          (val) => !existsStudiestedbrukerRolle(val.id, rolleTypeStudiested),
        );
      default:
        return [];
    }
  }, [rolleTypeStudiested, studiestedbrukereData, existsStudiestedbrukerRolle]);

  return (
    <Autocomplete
      id={`rolle-ss-autocomplete-${id}`}
      loading={studiestedbrukereLoading}
      label={labels.name}
      options={filtrerteStudiestedbrukere?.map(
        ({ fornavn, etternavn, ...ssbruker }) => ({
          ...ssbruker,
          navn: `${fornavn} ${etternavn}`,
        }),
      )}
      onChange={(event: object, value: StudiestedbrukerDto) => {
        onChange(value);
      }}
    />
  );
};

export default RollelisteStudiestedbrukerDropDown;
